import React, { useEffect, useState } from 'react'
import { BASEURL } from '../../configure';

export default function ImgContainer(props) {
  const [ getSrc, setSrc ] = useState('')
  let getPrjectDetails = async (valueId) => {
    let castImg = await fetch(BASEURL+'castImage/'+valueId+'?_embed', {
      method: 'GET',
    })
    const data = await castImg.json();
    setSrc(data)
    return data;
  }
  useEffect(()=>{
    getPrjectDetails(props.imgId)
  },[getSrc])
  return <img src={getSrc} style={{ width: "100%", height: "auto", maxHeight: "140px", objectFit: "cover" }}/>
}
